/** Route/query params stripped from SEO crawler URLs and navigation state. */
export const SEO_OMIT_PARAMS = [
    'examLevel',
    'subject',
    'question',
    'qp',
    'navigationData',
    'navigatedFrom',
    'seo_crawler',
];
export const SEO_OMIT_PARAM_SET = new Set(SEO_OMIT_PARAMS);
export function omitSeoParamsFromSearchParams(searchParams) {
    for (const key of SEO_OMIT_PARAMS) {
        searchParams.delete(key);
    }
}
